import K9Help from "./k9_help";
import { k9BetMoveEffect } from "./k9_bet_move_effect";
import GameUtil from "../../../../../utility/game_util";

//边池
const {ccclass, property} = cc._decorator;

interface ISidePotData{
    node:cc.Node;
    numbNode:cc.Node;
    sideRoot:cc.Node;
    betEffect:k9BetMoveEffect;
    target:cc.Node;
}

@ccclass
export default class K9SidePotEffect extends cc.Component {

    @property(cc.Node)
    prefab:cc.Node = null;

    private sidePool:ISidePotData[] = [];

    private width:number = 186;

    @property(cc.Node)
    rootNode:cc.Node = null;

    potNodesPos:any[] = null;

    onLoad(){
        if (!this.potNodesPos) {
            this.potNodesPos = [];
            for (let idx = 0; idx < 7; idx++) {
                let node = this.node.getChildByName('pot' + (idx+1));
                this.potNodesPos[idx] = [];
                for (let cx = 0; cx < node.childrenCount; cx++) {
                    let childNode = node.getChildByName('p' + (cx+1));
                    let worldPos = node.parent.convertToWorldSpaceAR(childNode.position);
                    this.potNodesPos[idx].push(worldPos);
                }
            }
        }
    }

    updatePos(){
        this.potNodesPos = [];
        for (let idx = 0; idx < 7; idx++) {
            let node = this.node.getChildByName('pot' + (idx+1));
            this.potNodesPos[idx] = [];
            for (let cx = 0; cx < node.childrenCount; cx++) {
                let childNode = node.getChildByName('p' + (cx+1));
                let worldPos = node.parent.convertToWorldSpaceAR(childNode.position);
                this.potNodesPos[idx].push(worldPos);
            }
        }
    }

    //更新边池,直接全部更新
    updateSidePot(data:any[]){
        //重置所有边池
        this.reset();
        this.updatePos();
        if (data.length > 7) {//只处理7个边池
            return;
        }

        for (let i = 0; i < data.length; i++) {
            if (data[i].betCoinSum == 0) {
                continue;
            }
            let side = this.sidePool[i];
            if (!side) {
                let node = K9Help.AddChild(this.prefab,this.rootNode);
                let sideRoot = node.getChildByName('Sideroot');
                let numbNode = sideRoot.getChildByName('numb');
                let target = node.getChildByName('target');
                let betEffect = node.getComponent(k9BetMoveEffect);
                side = {
                    node:node,
                    sideRoot:sideRoot,
                    numbNode:numbNode,
                    betEffect:betEffect,
                    target:target,
                }
                this.sidePool.push(side);
            }

            let max = data.length > 7 ? 7:data.length;
            let worldPos = this.potNodesPos[max-1][i];
            let pos = this.rootNode.parent.convertToNodeSpaceAR(worldPos);
            side.node.position = pos;

            side.sideRoot.active = true;
            let totalBet = data[i].betCoinSum;
            let numb = GameUtil.currencyFormatting(totalBet,2,true);
            K9Help.setNodeString(side.numbNode,numb);
            side.betEffect.showBet(totalBet);
        }
    }

    getPoolData(index:number){
        return this.sidePool[index];
    }

    recycleOneSidePot(index:number){
        let pool = this.sidePool[index];
        if (pool) {
            pool.sideRoot.active = false;
            pool.betEffect.recycleAllBet();
        }
    }

    reset(){
        for (let side of this.sidePool) {
            side.sideRoot.active = false;
            side.betEffect.recycleAllBet();
        }
    }

    clear(){
        for (let side of this.sidePool) {
            side.sideRoot.active = false;
            side.betEffect.recycleAllBet();
            side.betEffect.clear();
        }
    }
}
